"use client";

import styles from "@/styles/modules/components/homepage/module4.module.scss";
import { HomepageOptions } from "@/types/wordpress";
import Content from "../Content";
import { ContentComponent } from "@/types/modules";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "@/context/languageContext";

interface Module4Props {
  homepageOptions: HomepageOptions;
}

export default function Module4({ homepageOptions }: Module4Props) {
  const { language } = useContext(LanguageContext);
  const [data, setData] = useState(
    language === "en" ? homepageOptions.module4 : homepageOptions.module4DE
  );

  useEffect(() => {
    setData(
      language === "en" ? homepageOptions.module4 : homepageOptions.module4DE
    );
  }, [homepageOptions.module4, homepageOptions.module4DE, language]);

  const content: ContentComponent = {
    imageAlign: data.contentFields.imageAlign,
    textAlign: data.contentFields.textAlign,
    content: data.contentFields.body,
    gallery: data.contentFields.gallery,
    sameWidth: true,
    button: data.contentFields.button,
    ...(data.contentFields.title && {
      title: data.contentFields.title,
    }),
  };

  return (
    <section
      className={styles.module4}
      style={{
        backgroundColor:
          homepageOptions.module4.backgroundColor.backgroundColor || "",
        ["--section-color" as any]:
          homepageOptions.module3.backgroundColor.backgroundColor || "",
      }}
    >
      <div className={styles.module4Container}>
        <Content content={content} />
      </div>
    </section>
  );
}
